export const COND = "Condition";
export const OP = "Operator";
export const GT = 2;
export const LT = 3;
export const GTE = 4;
export const LTE = 5;
export const EQ = 6;
export const AND = 7;
export const OR = 8;
export const IS_NOT = 9;
export const CBA_RULE = "CBA";
export const CBI_RULE = "CBI";
export const CBM_RULE = "CBM";
export const LEFT = "left";
export const RIGHT = "right";
export const SEPARATOR = "-";
